import CryptoJS from 'crypto-js';

const passkey = 'SeCrET:KeY:BeHind:'.toString().padEnd(32, ' ');

const isStringified = (input: string = '') => {
  try {
    return JSON.parse(input);
  } catch {
    return input;
  }
};

export default class AsyncLocalStorage {
  /**
   *
   * @param key
   * @returns
   */
  public static async getItem(key: string): Promise<any | null> {
    const item = (await localStorage.getItem(key)) || '';
    return isStringified(
      passkey && item
        ? await CryptoJS.AES.decrypt(item, passkey, {
            iv: CryptoJS.enc.Utf8.parse(''),
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC,
          }).toString(CryptoJS.enc.Utf8)
        : JSON.stringify(item),
    );
  }

  /**
   *
   * @param key
   * @param value
   */
  public static async setItem(key: string, value: string): Promise<void> {
    if (passkey && value) {
      const item = await CryptoJS.AES.encrypt(value, passkey, {
        iv: CryptoJS.enc.Utf8.parse(''),
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }).toString();
      await localStorage.setItem(key, item);
    } else {
      await localStorage.setItem(key, value);
    }
  }

  /**
   *
   * @param key
   */
  public static removeItem(key: string): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      await localStorage.removeItem(key);
      resolve(true);
    });
  }

  /**
   *
   * @param keys
   */
  public static removeItems(keys: string[]): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      for (const key of keys) await localStorage.removeItem(key);
      resolve(true);
    });
  }
}
